import React, { useEffect, useState } from "react";
import { AdminSideBar } from "@milestone/component-library";
import styled from "styled-components";
import { NestedRoutes } from "../../app/routes.types";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setMembers } from "../../store/slices/MemberListSlice";
import { setTeamTypes } from "../../store/slices/TeamTypeSlice";
import { useMemberArray } from "../../services/hooks/MembersList";
import { useTeamTypesArray } from "../../services/hooks/TeamTypeList";
import { UserPermissions } from "../../enums";
import { useQueryClient } from "@tanstack/react-query";
import { Api } from "../../services/api";
import { TeamsQueryKeys } from "../../services/api/TeamsRepository";

const AdminContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
`;

const AdminContent = styled.div`
  height: 100%;
  padding: 22px 32px;
  box-sizing: border-box;
  flex-grow: 1;
  min-width: 0px;
  overflow-x: auto;
`;

export const AdminLayout: React.FC<{
  links?: Array<NestedRoutes>;
}> = props => {
  const user = useAppSelector(state => state.auth.user);
  const canViewMemberList = user.permissions.includes(
    UserPermissions.MemberViewList
  );
  const [teamTypesLoaded, setTeamTypesLoaded] = useState(false);
  const [membersLoaded, setMembersLoaded] = useState(!canViewMemberList);
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  try {
    //update members in redux store
    useMemberArray(setMembersLoaded, canViewMemberList).then(memberArray => {
      if (membersLoaded) dispatch(setMembers(memberArray));
    });
    //Get team types and store in Redux
    const teamTypes = useTeamTypesArray(setTeamTypesLoaded);
    if (teamTypesLoaded) dispatch(setTeamTypes(teamTypes));
  } catch (error) {
    console.error("Error?", error);
  }

  useEffect(() => {
    // prefetch teams data
    queryClient.prefetchQuery([TeamsQueryKeys.TEAMS], Api.teams.get);
  }, []);

  return (
    <AdminContainer>
      <AdminSideBar
        links={props.links || []}
        userPermissions={user.permissions}
      />
      <AdminContent>{props.children}</AdminContent>
    </AdminContainer>
  );
};
